module.exports = __webpack_public_path__ + "static/media/izlozba (9).c3ca346f.jpg";